import {TranslateService} from '@ngx-translate/core';

/**
 * The `TranslationUtil` class provides utility methods for translating text using the Angular TranslateService.
 *
 * Usage:
 * 1. Set the TranslateService instance using the setTranslateService method.
 * 2. Use the translate method to get translated text for a given key.
 * 3. Use the translateWithParameter method to get translated text with dynamic parameters.
 */
export class TranslationUtil {
  private static translateService: TranslateService;

  /**
   * Sets the TranslateService instance for translation.
   *
   * @param translateService - An instance of the Angular TranslateService.
   * @returns void
   */
  static setTranslateService(translateService: TranslateService): void {
    this.translateService = translateService;
  }

  /**
   * Translates the given key to the corresponding text.
   *
   * @param key - The translation key.
   * @returns The translated text.
   */
  static translate(key: string): string {
    return this.translateService.instant(key);
  }

  /**
   * Translates the given key to the corresponding text with dynamic parameters.
   *
   * @param key - The translation key.
   * @param param - An object containing dynamic parameters for the translation.
   * @returns The translated text with applied parameters.
   */
  static translateWithParameter(key: string, param: object): string {
    return this.translateService.instant(key, param);
  }
}
